import { Component } from 'react';

import styles from './index.module.scss';

type Props = {
    priority: number;
}

class DevCategoryPriority extends Component <Props, {}> {
    render() {
        return <div className={styles.devPriority}>{`Priority: ${this.props.priority}`}</div>;
    }
}

export default DevCategoryPriority;
